<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>About Us</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="our_company">
  <div class="site-section border-bottom">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6" data-aos="fade-up" data-aos-delay="100">
          <img
            src="../../../assets/images/logo.png"
            alt="Image"
            class="img-fluid"
          />
        </div>
        <div class="col-md-6 ml-auto" data-aos="fade-up" data-aos-delay="200">
          <div class="site-section-title mb-3">
            <br />
            <h2>Our Company</h2>
          </div>
          <p>
            Stride Real Estate is committed to providing you with a smooth,
            worry-free, home buying experience. Whether it be an investment
            opportunity, leasing, or selling your house, our agents are ready to
            bring their expertise so you can be at ease. Our customers are our
            top priority!
          </p>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="site-section">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-md-6 order-md-2"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <img
            src="../../../assets/images/office.jpeg"
            alt="Image"
            class="img-fluid"
          />
        </div>
        <div
          class="col-md-6 order-md-1"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="site-section-title mb-3">
            <br />
            <h2>Our Office</h2>
          </div>
          <p>
            We are delighted to be in the heart of North Dallas. Our office is
            conveniently located near Hwy 75 and Parker Rd. Stop by; we’d be
            happy to give you a cup of coffee (or water!) and a free
            consultation!
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
